

// // // // // import { Link } from "react-router-dom";



// // // // // function SubscriptionPackages() {

// // // // //     const isMobile = window.innerWidth <= 768;

// // // // //     return (
// // // // //         <>
// // // // //             <div className="col-lg-2">
// // // // //             </div>
// // // // //             <div className="col-lg-7">

// // // // //                 <p
// // // // //                     className="breadcrumb maamaas-home-bredcum"
// // // // //                     style={{
// // // // //                         position: "fixed",
// // // // //                         top: window.innerWidth <= 425 ? "50px" : window.innerWidth > 425 && window.innerWidth <= 768 ? "55px" : "64px",
// // // // //                         left: "2vw",
// // // // //                         width: "100%",
// // // // //                         backgroundColor: "#fff",
// // // // //                         zIndex: 1000,
// // // // //                         padding: "10px 0",
// // // // //                         fontSize: isMobile ? "16px" : "18px",
// // // // //                         fontWeight: isMobile ? "normal" : "bold",
// // // // //                         textAlign: "center",
// // // // //                         margin: 0,
// // // // //                     }}
// // // // //                 >

// // // // //                     <Link
// // // // //                         to="/foodladingpage"
// // // // //                         style={{
// // // // //                             color: "purple",
// // // // //                             fontWeight: "bold",
// // // // //                             textDecoration: "none",
// // // // //                         }}
// // // // //                     >
// // // // //                         Food & Beverages

// // // // //                     </Link>

// // // // //                     <span className="separator"> &gt; </span>
// // // // //                     <Link

// // // // //                         style={{
// // // // //                             color: "purple",
// // // // //                             fontWeight: "bold",
// // // // //                             textDecoration: "none",
// // // // //                         }}
// // // // //                     >
// // // // //                         Subscriptions
// // // // //                     </Link>
// // // // //                 </p>
// // // // //             </div>
// // // // //             <div className="col-lg-3">
// // // // //             </div>
// // // // //         </>
// // // // //     );
// // // // // }

// // // // // export default SubscriptionPackages;







// // // // import React, { useState, useEffect } from "react";
// // // // import { Link } from "react-router-dom";
// // // // import { FaUtensils, FaConciergeBell, FaStore, FaBuilding, FaShoppingBasket } from "react-icons/fa";
// // // // import Cloudbannerall from "./Cloudbannerall";
// // // // import Gelerycards from "./Gelerycards";
// // // // import "./Mainladdingpage.css";
// // // // import Mainnavbar from './Mainnavbar';
// // // // import Cateringbanner from './Cateringbanner.js';
// // // // import Franchiessbanner from './Franchiessbanner';
// // // // import Banquethallbanner from './Banquethallbanner';
// // // // import menu1 from "./download.jpg";
// // // // import LocalShippingIcon from '@mui/icons-material/LocalShipping';
// // // // import Logisticsbanner from "./Logisticsbanner"
// // // // import Foodandbeveragesadvertise from "../FoodandBeverages/Foodandbeveragesadvertise.js";
// // // // import Mainlandingadvertise from "./Mainlandingadvertise.js";


// // // // const SubscriptionPackages = () => {
// // // //     const [activeFilter, setActiveFilter] = useState("Food & Beverages");
// // // //     const [coupons, setCoupons] = useState([]);
// // // //     const [isHovered, setIsHovered] = useState(false);
// // // //     const isMobile = window.innerWidth <= 768;
// // // //     const dishImages = {
// // // //         1: { image: menu1 },
// // // //         2: { image: menu1 },
// // // //         3: { image: menu1 },
// // // //     };
// // // //     useEffect(() => {
// // // //         setCoupons([
// // // //             { code: "PIZZA50", discountPercentage: 50, dishId: 1 },
// // // //             { code: "BURGER30", discountPercentage: 30, dishId: 2 },
// // // //             { code: "DEL99", discountPercentage: 20, dishId: 3 },
// // // //         ]);
// // // //     }, []);

// // // //     const orderPosts = [
// // // //         { dishId: 1, orderType: "Create Limited-Time Deals!" },
// // // //         { dishId: 2, orderType: "Highlight Your Best Sellers!" },
// // // //         { dishId: 3, orderType: "Exclusive Discount Campaigns" },
// // // //         { dishId: 4, orderType: "Create Your Festive Offers" },
// // // //         { dishId: 5, orderType: "Create Your Festive Best Deals" },
// // // //         { dishId: 6, orderType: "Create Your Own Ads" },
// // // //         { dishId: 7, orderType: "Target Local Customers" },
// // // //         { dishId: 8, orderType: "Maximize Visibility" },
// // // //         { dishId: 9, orderType: "Boost Seasonal Sales" },
// // // //         { dishId: 10, orderType: "Create Exclusive Coupons" },
// // // //     ];

// // // //     const renderContent = () => {
// // // //         switch (activeFilter) {
// // // //             case "Food & Beverages":
// // // //                 return <Cloudbannerall />;
// // // //             case "Catering & Services":
// // // //                 return <Cateringbanner />;
// // // //             // case "Logistics & Supply":
// // // //             //     return <Logisticsbanner />;
// // // //             // case "Fresh & Grocery":
// // // //             //     return <Franchiessbanner />;
// // // //             // case "Banquet Hall":
// // // //             //     return <Banquethallbanner />;
// // // //             default:
// // // //                 return <Cloudbannerall />;
// // // //         }
// // // //     };

// // // //     const filterOptions = [
// // // //         { name: "Food & Beverages", icon: <FaUtensils /> },
// // // //         { name: "Catering & Services", icon: <FaConciergeBell /> },
// // // //         // { name: "Logistics & Supply", icon: <LocalShippingIcon /> },
// // // //         // { name: "Fresh & Grocery", icon: <FaShoppingBasket /> }, // Grocery category
// // // //         // { name: "Banquet Hall", icon: <FaBuilding /> },
// // // //     ];

// // // //     return (
// // // //         <div>
// // // //             <p
// // // //                 className="breadcrumb maamaas-home-bredcum"
// // // //                 style={{
// // // //                     position: "fixed",
// // // //                     top: window.innerWidth <= 425 ? " 50px" : window.innerWidth > 425 && window.innerWidth <= 768 ? "55px" : "64px",
// // // //                     left: "2vw",
// // // //                     width: "100%",
// // // //                     backgroundColor: "#fff",
// // // //                     zIndex: window.innerWidth <= 998 ? 1000 : 1000,
// // // //                     padding: "10px 0",
// // // //                     fontSize: isMobile ? "16px" : "18px",
// // // //                     fontWeight: isMobile ? "normal" : "bold",
// // // //                     textAlign: "center",
// // // //                     margin: 0,
// // // //                 }}
// // // //             >
// // // //                 <Link
// // // //                     to="/fooddashboard"
// // // //                     style={{
// // // //                         color: "purple",
// // // //                         fontWeight: "bold",
// // // //                         textDecoration: "none",
// // // //                     }}
// // // //                 >
// // // //                     Home
// // // //                 </Link>
// // // //                 <span className="separator"> &gt; </span>
// // // //                 <Link
// // // //                     // to="/foodladingpage"
// // // //                     style={{
// // // //                         color: "purple",
// // // //                         fontWeight: "bold",
// // // //                         textDecoration: "none",
// // // //                     }}
// // // //                 >
// // // //                     Subscription
// // // //                 </Link>

// // // //                 {/* <span className="separator"> &gt; </span> */}



// // // //             </p>
// // // //             <Mainnavbar />
// // // //             <div style={{ justifyContent: 'center' }} className="container-fluid main-container">
// // // //                 <div className="row">
// // // //                     {/* Sidebar */}
// // // //                     <div className="col-lg-2 col-md-12 col-sm-12 sidebar">
// // // //                         <ul className="filter-list" style={{ marginTop: "10px" }}>
// // // //                             {filterOptions.map((item) => (
// // // //                                 <li
// // // //                                     key={item.name}
// // // //                                     className={`filter-item ${activeFilter === item.name ? "active" : ""}`}
// // // //                                     onClick={() => setActiveFilter(item.name)}
// // // //                                 >
// // // //                                     <span className="icon">{item.icon}</span>
// // // //                                     <span className="text">{item.name}</span>
// // // //                                 </li>
// // // //                             ))}
// // // //                         </ul>
// // // //                     </div>

// // // //                     {/* Content */}
// // // //                     <div
// // // //                         className="col-lg-8 col-md-12 col-sm-12 content-area"
// // // //                         style={{ height: "80vh", overflow: "auto", scrollbarWidth: "none", }}
// // // //                     >


// // // //                         <div style={{ padding: "15px", marginTop: "50px" }} className="main-banner-mobile">{renderContent()}</div>
// // // //                     </div>

// // // //                     {/* Right Panel (Hidden on Mobile) */}
// // // //                     <div className="col-lg-2 col-md-12 col-sm-12 right-panel">
// // // //                         <div className="right-panel-inner">

// // // //                             {/* {orderPosts.map((post, index) => (
// // // //                                 <div
// // // //                                     key={`${post.dishId}-${index}`}
// // // //                                     className="promotion-card"
// // // //                                 >
// // // //                                     <h6>{post.orderType}</h6>
// // // //                                     <Link to="/promotions" className="promotion-link">
// // // //                                         <button className="promotion-button">
// // // //                                             Add Promotions
// // // //                                         </button>
// // // //                                     </Link>
// // // //                                 </div>
// // // //                             ))} */}
// // // //                             <Mainlandingadvertise />


// // // //                         </div>
// // // //                     </div>
// // // //                 </div>
// // // //             </div>

// // // //             {/* Internal CSS for responsiveness */}
// // // //             <style>
// // // //                 {`
// // // //           .sidebar {
// // // //             padding: 15px;
// // // //           }

// // // //           .filter-list {
// // // //             list-style: none;
// // // //             padding: 0;
// // // //           }

// // // //           .filter-item {
// // // //             display: flex;
// // // //             align-items: center;
// // // //             gap: 2px;
// // // //             padding: 10px;
// // // //             cursor: pointer;
// // // //             border-radius: 6px;
// // // //           }

// // // //           .filter-item.active {
// // // //             background: #b15cd6;
// // // //             color: #fff;
// // // //           }

// // // //           .filter-item:hover {
// // // //             background: #f2e6f9;
// // // //           }

// // // //           /* Hide right panel on tablets and below */
// // // //           @media (max-width: 991px) {
// // // //             .right-panel {
// // // //               display: none !important;
// // // //             }
// // // //           }

// // // //           /* Sidebar full width on mobile */
// // // //           @media (max-width: 768px) {
// // // //             .sidebar {
// // // //               width: 100% !important;
// // // //               margin-bottom: 10px;
// // // //               background: #fafafa;
// // // //               border-bottom: 0px solid #ddd;
// // // //             }
// // // //             .filter-item {
// // // //               justify-content: flex-start;
// // // //             }
// // // //             .content-area {
// // // //               margin-top: 15px;
// // // //             }
// // // //               .main-banner-mobile{
// // // //               width:96vw !important;
// // // //               }
// // // //               .main-container{
// // // //               margin-top:15px !important;
// // // //               }
// // // //           }

// // // //         `}
// // // //             </style>
// // // //         </div>
// // // //     );
// // // // };

// // // // export default SubscriptionPackages;





// // // import React, { useState } from "react";
// // // import { Link } from "react-router-dom";

// // // function SubscriptionPackages() {
// // //     const isMobile = window.innerWidth <= 768;
// // //     const [selectedServices, setSelectedServices] = useState({
// // //         DINE_IN: false,
// // //         TAKEAWAY: false,
// // //         DELIVERY: false,
// // //         TABLE_DINE_IN: false,
// // //         CATERINGS_SERVICES: false
// // //     });

// // //     // Service type configurations
// // //     const serviceTypes = [
// // //         { id: "DINE_IN", label: "Dine-In", color: "#4CAF50", icon: "🍽️" },
// // //         { id: "TAKEAWAY", label: "Takeaway", color: "#2196F3", icon: "🥡" },
// // //         { id: "DELIVERY", label: "Delivery", color: "#FF9800", icon: "🚚" },
// // //         { id: "TABLE_DINE_IN", label: "Table Dine-In", color: "#9C27B0", icon: "🏪" },
// // //         { id: "CATERINGS_SERVICES", label: "Catering Services", color: "#E91E63", icon: "🎪" }
// // //     ];

// // //     // Subscription plans data based on selected services
// // //     const getSubscriptionData = () => {
// // //         // If no service is selected, show all or default
// // //         const isSelected = Object.values(selectedServices).some(val => val);

// // //         if (!isSelected) {
// // //             return {
// // //                 title: "Select Service Types to View Plans",
// // //                 description: "Please select at least one service type to view available subscription plans.",
// // //                 plans: [],
// // //                 features: []
// // //             };
// // //         }

// // //         // Check what's selected
// // //         const foodServices = [
// // //             selectedServices.DINE_IN,
// // //             selectedServices.TAKEAWAY,
// // //             selectedServices.DELIVERY,
// // //             selectedServices.TABLE_DINE_IN
// // //         ].some(val => val);

// // //         const cateringSelected = selectedServices.CATERINGS_SERVICES;

// // //         if (foodServices && cateringSelected) {
// // //             return {
// // //                 title: "Food & Beverages + Catering Services",
// // //                 description: "Combined subscription plans for restaurant and catering services.",
// // //                 plans: [
// // //                     { name: "BASIC", price: "₹5,000", days: "30", features: ["Home", "Company", "Menu"] },
// // //                     { name: "STANDARD", price: "₹10,000", days: "90", features: ["Home", "Company", "Menu", "Orders"] },
// // //                     { name: "PREMIUM", price: "₹20,000", days: "180", features: ["Home", "Company", "Menu", "Orders", "Inventory"] }
// // //                 ],
// // //                 features: ["Home", "Company", "Settings", "Menu", "Orders", "Inventory", "Reports", "Promotions"]
// // //             };
// // //         } else if (foodServices) {
// // //             return {
// // //                 title: "Food & Beverages Subscription Plans",
// // //                 description: "Subscription plans for restaurant services including dine-in, takeaway, delivery, and table service.",
// // //                 plans: [
// // //                     { name: "BASIC", price: "₹3,000", days: "30", features: ["Home", "Company", "Menu"] },
// // //                     { name: "STANDARD", price: "₹7,000", days: "90", features: ["Home", "Company", "Menu", "Orders"] },
// // //                     { name: "PREMIUM", price: "₹15,000", days: "180", features: ["Home", "Company", "Menu", "Orders", "Inventory", "Reports"] }
// // //                 ],
// // //                 features: ["Home", "Company", "Settings", "Menu", "Orders", "Chef Panel", "Tables", "Delivery", "Inventory", "Reports"]
// // //             };
// // //         } else if (cateringSelected) {
// // //             return {
// // //                 title: "Catering Services Subscription Plans",
// // //                 description: "Subscription plans for catering and event services.",
// // //                 plans: [
// // //                     { name: "VISIBILITY_LEAD", price: "₹8,000", days: "30", features: ["Home", "Company", "Booking"] },
// // //                     { name: "BOOKINGS", price: "₹15,000", days: "90", features: ["Home", "Company", "Booking", "Orders"] },
// // //                     { name: "PREMIUM", price: "₹25,000", days: "180", features: ["Home", "Company", "Booking", "Orders", "Staff", "Reports"] }
// // //                 ],
// // //                 features: ["Home", "Company", "Settings", "Booking", "Orders", "Staff", "Reports", "Promotions"]
// // //             };
// // //         }

// // //         return {
// // //             title: "No Plans Available",
// // //             description: "Please select service types to view plans.",
// // //             plans: [],
// // //             features: []
// // //         };
// // //     };

// // //     const handleServiceToggle = (serviceId) => {
// // //         setSelectedServices(prev => ({
// // //             ...prev,
// // //             [serviceId]: !prev[serviceId]
// // //         }));
// // //     };

// // //     const subscriptionData = getSubscriptionData();

// // //     return (
// // //         <>
// // //             <div className="container-fluid company-mobile-data"
// // //                 style={{
// // //                     height: "500px"
// // //                 }}
// // //             >
// // //                 <div className="row">


// // //                     <div className="col-lg-2"></div>
// // //                     <div className="col-lg-7">
// // //                         <p
// // //                             className="breadcrumb maamaas-home-bredcum"
// // //                             style={{
// // //                                 position: "fixed",
// // //                                 top: window.innerWidth <= 425 ? "50px" : window.innerWidth > 425 && window.innerWidth <= 768 ? "55px" : "64px",
// // //                                 left: "2vw",
// // //                                 width: "100%",
// // //                                 backgroundColor: "#fff",
// // //                                 zIndex: 1000,
// // //                                 padding: "10px 0",
// // //                                 fontSize: isMobile ? "16px" : "18px",
// // //                                 fontWeight: isMobile ? "normal" : "bold",
// // //                                 textAlign: "center",
// // //                                 margin: 0,
// // //                             }}
// // //                         >
// // //                             <Link
// // //                                 to="/foodladingpage"
// // //                                 style={{
// // //                                     color: "purple",
// // //                                     fontWeight: "bold",
// // //                                     textDecoration: "none",
// // //                                 }}
// // //                             >
// // //                                 Food & Beverages
// // //                             </Link>
// // //                             <span className="separator"> &gt; </span>
// // //                             <Link
// // //                                 style={{
// // //                                     color: "purple",
// // //                                     fontWeight: "bold",
// // //                                     textDecoration: "none",
// // //                                 }}
// // //                             >
// // //                                 Subscriptions
// // //                             </Link>
// // //                         </p>

// // //                         {/* Main Content Container */}
// // //                         <div style={{
// // //                             marginTop: "80px",
// // //                             padding: isMobile ? "15px" : "20px",
// // //                             backgroundColor: "#fff",
// // //                             borderRadius: "10px",
// // //                             boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
// // //                         }}>
// // //                             {/* Service Selection Section */}
// // //                             <div style={{ marginBottom: "30px" }}>
// // //                                 <h3 style={{
// // //                                     marginBottom: "20px",
// // //                                     color: "#333",
// // //                                     fontSize: isMobile ? "18px" : "20px"
// // //                                 }}>
// // //                                     Select Service Types
// // //                                 </h3>

// // //                                 <div style={{
// // //                                     display: "flex",
// // //                                     flexWrap: "wrap",
// // //                                     gap: "15px",
// // //                                     justifyContent: isMobile ? "center" : "flex-start"
// // //                                 }}>
// // //                                     {serviceTypes.map(service => (
// // //                                         <div
// // //                                             key={service.id}
// // //                                             style={{
// // //                                                 display: "flex",
// // //                                                 alignItems: "center",
// // //                                                 padding: "12px 20px",
// // //                                                 backgroundColor: selectedServices[service.id] ? service.color : "#f5f5f5",
// // //                                                 borderRadius: "8px",
// // //                                                 cursor: "pointer",
// // //                                                 transition: "all 0.3s ease",
// // //                                                 border: `2px solid ${selectedServices[service.id] ? service.color : "#e0e0e0"}`,
// // //                                                 minWidth: isMobile ? "140px" : "160px",
// // //                                                 justifyContent: "center"
// // //                                             }}
// // //                                             onClick={() => handleServiceToggle(service.id)}
// // //                                         >
// // //                                             <span style={{
// // //                                                 fontSize: "20px",
// // //                                                 marginRight: "10px"
// // //                                             }}>
// // //                                                 {service.icon}
// // //                                             </span>
// // //                                             <div>
// // //                                                 <div style={{
// // //                                                     fontWeight: "bold",
// // //                                                     color: selectedServices[service.id] ? "#fff" : "#333",
// // //                                                     fontSize: isMobile ? "14px" : "15px"
// // //                                                 }}>
// // //                                                     {service.label}
// // //                                                 </div>
// // //                                                 <div style={{
// // //                                                     fontSize: "12px",
// // //                                                     color: selectedServices[service.id] ? "rgba(255,255,255,0.9)" : "#666",
// // //                                                     marginTop: "2px"
// // //                                                 }}>
// // //                                                     {selectedServices[service.id] ? "✓ Selected" : "Click to select"}
// // //                                                 </div>
// // //                                             </div>
// // //                                         </div>
// // //                                     ))}
// // //                                 </div>

// // //                                 {/* Selected Services Summary */}
// // //                                 <div style={{
// // //                                     marginTop: "20px",
// // //                                     padding: "15px",
// // //                                     backgroundColor: "#f8f9fa",
// // //                                     borderRadius: "8px",
// // //                                     borderLeft: "4px solid #b15cd6"
// // //                                 }}>
// // //                                     <div style={{
// // //                                         display: "flex",
// // //                                         alignItems: "center",
// // //                                         justifyContent: "space-between",
// // //                                         flexWrap: "wrap",
// // //                                         gap: "10px"
// // //                                     }}>
// // //                                         <div>
// // //                                             <strong style={{ color: "#555" }}>Selected Services:</strong>
// // //                                             <span style={{
// // //                                                 marginLeft: "10px",
// // //                                                 color: "#666",
// // //                                                 fontSize: "14px"
// // //                                             }}>
// // //                                                 {Object.keys(selectedServices)
// // //                                                     .filter(key => selectedServices[key])
// // //                                                     .map(key => serviceTypes.find(s => s.id === key)?.label)
// // //                                                     .join(", ") || "None selected"}
// // //                                             </span>
// // //                                         </div>
// // //                                         <button
// // //                                             onClick={() => setSelectedServices({
// // //                                                 DINE_IN: false,
// // //                                                 TAKEAWAY: false,
// // //                                                 DELIVERY: false,
// // //                                                 TABLE_DINE_IN: false,
// // //                                                 CATERINGS_SERVICES: false
// // //                                             })}
// // //                                             style={{
// // //                                                 padding: "6px 12px",
// // //                                                 backgroundColor: "#f44336",
// // //                                                 color: "white",
// // //                                                 border: "none",
// // //                                                 borderRadius: "4px",
// // //                                                 fontSize: "12px",
// // //                                                 cursor: "pointer"
// // //                                             }}
// // //                                         >
// // //                                             Clear All
// // //                                         </button>
// // //                                     </div>
// // //                                 </div>
// // //                             </div>

// // //                             {/* Subscription Plans Section */}
// // //                             <div>
// // //                                 <h2 style={{
// // //                                     textAlign: "center",
// // //                                     color: "#b15cd6",
// // //                                     marginBottom: "10px",
// // //                                     fontSize: isMobile ? "20px" : "24px"
// // //                                 }}>
// // //                                     {subscriptionData.title}
// // //                                 </h2>

// // //                                 <p style={{
// // //                                     textAlign: "center",
// // //                                     color: "#666",
// // //                                     marginBottom: "30px",
// // //                                     fontSize: isMobile ? "14px" : "16px",
// // //                                     lineHeight: "1.5"
// // //                                 }}>
// // //                                     {subscriptionData.description}
// // //                                 </p>

// // //                                 {/* Subscription Plans Table */}
// // //                                 {subscriptionData.plans.length > 0 ? (
// // //                                     <div style={{
// // //                                         overflowX: "auto",
// // //                                         borderRadius: "8px",
// // //                                         border: "1px solid #e0e0e0"
// // //                                     }}>
// // //                                         <table style={{
// // //                                             width: "100%",
// // //                                             borderCollapse: "collapse",
// // //                                             minWidth: isMobile ? "600px" : "auto"
// // //                                         }}>
// // //                                             <thead>
// // //                                                 <tr style={{ backgroundColor: "#b15cd6" }}>
// // //                                                     <th style={tableHeaderStyle}>Features</th>
// // //                                                     {subscriptionData.plans.map(plan => (
// // //                                                         <th key={plan.name} style={tableHeaderStyle}>
// // //                                                             <div style={{
// // //                                                                 fontSize: "16px",
// // //                                                                 fontWeight: "bold",
// // //                                                                 marginBottom: "5px"
// // //                                                             }}>
// // //                                                                 {plan.name}
// // //                                                             </div>
// // //                                                             <div style={{ fontSize: "14px" }}>
// // //                                                                 {plan.days} Days
// // //                                                             </div>
// // //                                                             <div style={{
// // //                                                                 fontSize: "18px",
// // //                                                                 fontWeight: "bold",
// // //                                                                 marginTop: "5px"
// // //                                                             }}>
// // //                                                                 {plan.price}
// // //                                                             </div>
// // //                                                         </th>
// // //                                                     ))}
// // //                                                 </tr>
// // //                                             </thead>
// // //                                             <tbody>
// // //                                                 {subscriptionData.features.map((feature, index) => (
// // //                                                     <tr key={feature} style={{
// // //                                                         backgroundColor: index % 2 === 0 ? "#fff" : "#f9f9f9"
// // //                                                     }}>
// // //                                                         <td style={featureCellStyle}>
// // //                                                             {feature}
// // //                                                         </td>
// // //                                                         {subscriptionData.plans.map(plan => (
// // //                                                             <td key={`${plan.name}-${feature}`} style={featureCellStyle}>
// // //                                                                 {plan.features.includes(feature) ? (
// // //                                                                     <span style={{
// // //                                                                         color: "#4CAF50",
// // //                                                                         fontWeight: "bold",
// // //                                                                         fontSize: "18px"
// // //                                                                     }}>✓</span>
// // //                                                                 ) : (
// // //                                                                     <span style={{
// // //                                                                         color: "#f44336",
// // //                                                                         fontSize: "18px"
// // //                                                                     }}>✗</span>
// // //                                                                 )}
// // //                                                             </td>
// // //                                                         ))}
// // //                                                     </tr>
// // //                                                 ))}

// // //                                                 {/* Action Row */}
// // //                                                 <tr>
// // //                                                     <td style={{
// // //                                                         ...featureCellStyle,
// // //                                                         fontWeight: "bold",
// // //                                                         backgroundColor: "#f8f9fa"
// // //                                                     }}>
// // //                                                         Action
// // //                                                     </td>
// // //                                                     {subscriptionData.plans.map(plan => (
// // //                                                         <td key={`action-${plan.name}`} style={{
// // //                                                             ...featureCellStyle,
// // //                                                             backgroundColor: "#f8f9fa"
// // //                                                         }}>
// // //                                                             <button
// // //                                                                 style={{
// // //                                                                     padding: "8px 16px",
// // //                                                                     backgroundColor: "#4CAF50",
// // //                                                                     color: "white",
// // //                                                                     border: "none",
// // //                                                                     borderRadius: "4px",
// // //                                                                     fontWeight: "bold",
// // //                                                                     cursor: "pointer",
// // //                                                                     width: "100%",
// // //                                                                     fontSize: isMobile ? "13px" : "14px"
// // //                                                                 }}
// // //                                                                 onClick={() => alert(`Selected ${plan.name} plan for ${subscriptionData.title}`)}
// // //                                                             >
// // //                                                                 Subscribe Now
// // //                                                             </button>
// // //                                                         </td>
// // //                                                     ))}
// // //                                                 </tr>
// // //                                             </tbody>
// // //                                         </table>
// // //                                     </div>
// // //                                 ) : (
// // //                                     <div style={{
// // //                                         textAlign: "center",
// // //                                         padding: "40px",
// // //                                         backgroundColor: "#f8f9fa",
// // //                                         borderRadius: "8px",
// // //                                         border: "2px dashed #ddd"
// // //                                     }}>
// // //                                         <div style={{ fontSize: "48px", marginBottom: "20px" }}>📋</div>
// // //                                         <h4 style={{ color: "#666", marginBottom: "10px" }}>
// // //                                             No Plans to Display
// // //                                         </h4>
// // //                                         <p style={{ color: "#888" }}>
// // //                                             Select one or more service types above to view available subscription plans.
// // //                                         </p>
// // //                                     </div>
// // //                                 )}
// // //                             </div>

// // //                             {/* Additional Information */}
// // //                             <div style={{
// // //                                 marginTop: "30px",
// // //                                 padding: "20px",
// // //                                 backgroundColor: "#f0f7ff",
// // //                                 borderRadius: "8px",
// // //                                 borderLeft: "4px solid #2196F3"
// // //                             }}>
// // //                                 <h4 style={{ color: "#2196F3", marginBottom: "10px" }}>
// // //                                     📝 Important Information
// // //                                 </h4>
// // //                                 <ul style={{
// // //                                     color: "#555",
// // //                                     paddingLeft: "20px",
// // //                                     fontSize: "14px",
// // //                                     lineHeight: "1.6"
// // //                                 }}>
// // //                                     <li>Prices are inclusive of all taxes</li>
// // //                                     <li>Plans auto-renew unless cancelled 7 days before expiry</li>
// // //                                     <li>Multi-service discounts available when selecting multiple services</li>
// // //                                     <li>24/7 customer support included with all plans</li>
// // //                                     <li>Free trial available for first-time subscribers</li>
// // //                                 </ul>
// // //                             </div>
// // //                         </div>
// // //                     </div>
// // //                     <div className="col-lg-3"></div>

// // //                     {/* Responsive CSS */}
// // //                     <style>{`
// // //                 @media (max-width: 768px) {
// // //                     .col-lg-7 {
// // //                         width: 100% !important;
// // //                         padding: 0 10px;
// // //                     }

// // //                     table {
// // //                         font-size: 12px;
// // //                     }
// // //                 }

// // //                 @media (min-width: 769px) and (max-width: 1024px) {
// // //                     .col-lg-7 {
// // //                         width: 70% !important;
// // //                     }
// // //                 }

// // //                 @media (min-width: 1025px) {
// // //                     .col-lg-7 {
// // //                         width: 70% !important;
// // //                     }
// // //                 }
// // //                 `}</style>
// // //                 </div>

// // //             </div >
// // //         </>
// // //     );
// // // }

// // // // Table style constants
// // // const tableHeaderStyle = {
// // //     padding: "15px",
// // //     textAlign: "center",
// // //     color: "white",
// // //     border: "1px solid #ddd",
// // //     minWidth: "150px"
// // // };

// // // const featureCellStyle = {
// // //     padding: "12px 15px",
// // //     textAlign: "center",
// // //     border: "1px solid #e0e0e0",
// // //     color: "#333"
// // // };

// // // export default SubscriptionPackages;



// // import React, { useState } from "react";
// // import { Link } from "react-router-dom";

// // function SubscriptionPackages() {
// //     const isMobile = window.innerWidth <= 768;
// //     // Set DINE_IN as default selected
// //     const [selectedServices, setSelectedServices] = useState({
// //         DINE_IN: true,
// //         TAKEAWAY: false,
// //         DELIVERY: false,
// //         TABLE_DINE_IN: false,
// //         CATERINGS_SERVICES: false
// //     });

// //     // Service type configurations
// //     const serviceTypes = [
// //         { id: "DINE_IN", label: "Dine-In" },
// //         { id: "TAKEAWAY", label: "Takeaway" },
// //         { id: "DELIVERY", label: "Delivery" },
// //         { id: "TABLE_DINE_IN", label: "Table Dine-In" },
// //         { id: "CATERINGS_SERVICES", label: "Catering Services" }
// //     ];

// //     // Subscription plans data based on selected services
// //     const getSubscriptionData = () => {
// //         // Check what's selected
// //         const foodServices = [
// //             selectedServices.DINE_IN,
// //             selectedServices.TAKEAWAY,
// //             selectedServices.DELIVERY,
// //             selectedServices.TABLE_DINE_IN
// //         ].some(val => val);

// //         const cateringSelected = selectedServices.CATERINGS_SERVICES;

// //         if (foodServices && cateringSelected) {
// //             return {
// //                 title: "Food & Beverages + Catering Services",
// //                 description: "Combined subscription plans for restaurant and catering services.",
// //                 plans: [
// //                     { name: "BASIC", price: "₹5,000", days: "30", features: ["Home", "Company", "Menu"] },
// //                     { name: "STANDARD", price: "₹10,000", days: "90", features: ["Home", "Company", "Menu", "Orders"] },
// //                     { name: "PREMIUM", price: "₹20,000", days: "180", features: ["Home", "Company", "Menu", "Orders", "Inventory"] }
// //                 ],
// //                 features: ["Home", "Company", "Settings", "Menu", "Orders", "Inventory", "Reports", "Promotions"]
// //             };
// //         } else if (foodServices) {
// //             return {
// //                 title: "Food & Beverages Subscription Plans",
// //                 description: "Subscription plans for restaurant services including dine-in, takeaway, delivery, and table service.",
// //                 plans: [
// //                     { name: "BASIC", price: "₹3,000", days: "30", features: ["Home", "Company", "Menu"] },
// //                     { name: "STANDARD", price: "₹7,000", days: "90", features: ["Home", "Company", "Menu", "Orders"] },
// //                     { name: "PREMIUM", price: "₹15,000", days: "180", features: ["Home", "Company", "Menu", "Orders", "Inventory", "Reports"] }
// //                 ],
// //                 features: ["Home", "Company", "Settings", "Menu", "Orders", "Chef Panel", "Tables", "Delivery", "Inventory", "Reports"]
// //             };
// //         } else if (cateringSelected) {
// //             return {
// //                 title: "Catering Services Subscription Plans",
// //                 description: "Subscription plans for catering and event services.",
// //                 plans: [
// //                     { name: "VISIBILITY_LEAD", price: "₹8,000", days: "30", features: ["Home", "Company", "Booking"] },
// //                     { name: "BOOKINGS", price: "₹15,000", days: "90", features: ["Home", "Company", "Booking", "Orders"] },
// //                     { name: "PREMIUM", price: "₹25,000", days: "180", features: ["Home", "Company", "Booking", "Orders", "Staff", "Reports"] }
// //                 ],
// //                 features: ["Home", "Company", "Settings", "Booking", "Orders", "Staff", "Reports", "Promotions"]
// //             };
// //         }

// //         return {
// //             title: "Please select service types to view plans.",
// //             // description: "Please select service types to view plans.",
// //             plans: [],
// //             features: []
// //         };
// //     };

// //     const handleServiceToggle = (serviceId) => {
// //         setSelectedServices(prev => ({
// //             ...prev,
// //             [serviceId]: !prev[serviceId]
// //         }));
// //     };

// //     const subscriptionData = getSubscriptionData();

// //     return (
// //         <>
// //             <div className="container-fluid company-mobile-data">
// //                 <div className="row">
// //                     <div className="col-lg-2"></div>
// //                     <div className="col-lg-7">
// //                         <p
// //                             className="breadcrumb maamaas-home-bredcum"
// //                             style={{
// //                                 position: "fixed",
// //                                 top: window.innerWidth <= 425 ? "50px" : window.innerWidth > 425 && window.innerWidth <= 768 ? "55px" : "64px",
// //                                 left: "2vw",
// //                                 width: "100%",
// //                                 backgroundColor: "#fff",
// //                                 zIndex: 1000,
// //                                 padding: "10px 0",
// //                                 fontSize: isMobile ? "16px" : "18px",
// //                                 fontWeight: isMobile ? "normal" : "bold",
// //                                 textAlign: "center",
// //                                 margin: 0,
// //                             }}
// //                         >
// //                             <Link
// //                                 to="/foodladingpage"
// //                                 style={{
// //                                     color: "purple",
// //                                     fontWeight: "bold",
// //                                     textDecoration: "none",
// //                                 }}
// //                             >
// //                                 Food & Beverages
// //                             </Link>
// //                             <span className="separator"> &gt; </span>
// //                             <Link
// //                                 style={{
// //                                     color: "purple",
// //                                     fontWeight: "bold",
// //                                     textDecoration: "none",
// //                                 }}
// //                             >
// //                                 Subscriptions
// //                             </Link>
// //                         </p>

// //                         {/* Main Content Container */}
// //                         <div style={{
// //                             marginTop: "100px",
// //                             padding: isMobile ? "15px" : "20px",
// //                             backgroundColor: "#fff",
// //                             borderRadius: "10px",
// //                         }}>
// //                             {/* Service Selection Section - Simple Checkboxes */}
// //                             <div style={{ marginBottom: "30px" }}>
// //                                 <h3 style={{
// //                                     marginBottom: "15px",
// //                                     color: "#333",
// //                                     fontSize: isMobile ? "18px" : "20px"
// //                                 }}>
// //                                     Select Service Types
// //                                 </h3>

// //                                 <div style={{
// //                                     display: "flex",
// //                                     flexWrap: "wrap",
// //                                     gap: "20px",
// //                                     alignItems: "center",
// //                                     padding: "15px",
// //                                     backgroundColor: "#f8f9fa",
// //                                     borderRadius: "8px",
// //                                     border: "1px solid #e0e0e0"
// //                                 }}>
// //                                     {serviceTypes.map(service => (
// //                                         <label
// //                                             key={service.id}
// //                                             style={{
// //                                                 display: "flex",
// //                                                 alignItems: "center",
// //                                                 gap: "8px",
// //                                                 cursor: "pointer",
// //                                                 fontSize: isMobile ? "14px" : "16px",
// //                                                 fontWeight: selectedServices[service.id] ? "normal" : "normal",
// //                                                 color: selectedServices[service.id] ? "#b15cd6" : "#333"
// //                                             }}
// //                                         >
// //                                             <input
// //                                                 type="checkbox"
// //                                                 checked={selectedServices[service.id]}
// //                                                 onChange={() => handleServiceToggle(service.id)}
// //                                                 style={{
// //                                                     width: "18px",
// //                                                     height: "18px",
// //                                                     cursor: "pointer",
// //                                                     accentColor: "#b15cd6"
// //                                                 }}
// //                                             />
// //                                             {service.label}
// //                                         </label>
// //                                     ))}
// //                                 </div>


// //                             </div>

// //                             {/* Subscription Plans Section */}
// //                             <div>
// //                                 <h2 style={{
// //                                     textAlign: "center",
// //                                     color: "#b15cd6",
// //                                     marginBottom: "10px",
// //                                     fontSize: isMobile ? "20px" : "24px"
// //                                 }}>
// //                                     {subscriptionData.title}
// //                                 </h2>

// //                                 <p style={{
// //                                     textAlign: "center",
// //                                     color: "#666",
// //                                     marginBottom: "30px",
// //                                     fontSize: isMobile ? "14px" : "16px",
// //                                     lineHeight: "1.5"
// //                                 }}>
// //                                     {subscriptionData.description}
// //                                 </p>

// //                                 {/* Subscription Plans Table - Matching your reference components */}
// //                                 {subscriptionData.plans.length > 0 ? (
// //                                     <div style={{
// //                                         overflowX: "auto",
// //                                         borderRadius: "8px",
// //                                         border: "1px solid #ddd"
// //                                     }}>
// //                                         <table style={{
// //                                             width: "100%",
// //                                             borderCollapse: "collapse",
// //                                             minWidth: isMobile ? "600px" : "auto"
// //                                         }}>
// //                                             <thead>
// //                                                 <tr>
// //                                                     <th style={{
// //                                                         border: "1px solid #ccc",
// //                                                         padding: "12px",
// //                                                         textAlign: "center",
// //                                                         fontWeight: "bold",
// //                                                         backgroundColor: "#b15cd6",
// //                                                         color: "white",
// //                                                         fontSize: isMobile ? "14px" : "16px"
// //                                                     }}>
// //                                                         Feature
// //                                                     </th>
// //                                                     {subscriptionData.plans.map((plan, index) => (
// //                                                         <th key={plan.name} style={{
// //                                                             border: "1px solid #ccc",
// //                                                             padding: "12px",
// //                                                             textAlign: "center",
// //                                                             fontWeight: "bold",
// //                                                             backgroundColor: "#b15cd6",
// //                                                             color: "white",
// //                                                             fontSize: isMobile ? "14px" : "16px"
// //                                                         }}>
// //                                                             <div style={{ fontSize: "16px", fontWeight: "bold" }}>
// //                                                                 {plan.days} Days
// //                                                             </div>
// //                                                         </th>
// //                                                     ))}
// //                                                 </tr>
// //                                             </thead>
// //                                             <tbody>
// //                                                 {/* Price Row */}
// //                                                 <tr>
// //                                                     <td style={{
// //                                                         border: "1px solid #ccc",
// //                                                         padding: "10px",
// //                                                         fontWeight: "bold",
// //                                                         backgroundColor: "#f9f9f9"
// //                                                     }}>
// //                                                         Price
// //                                                     </td>
// //                                                     {subscriptionData.plans.map(plan => (
// //                                                         <td key={`price-${plan.name}`} style={{
// //                                                             border: "1px solid #ccc",
// //                                                             padding: "10px",
// //                                                             textAlign: "center",
// //                                                             fontWeight: "bold"
// //                                                         }}>
// //                                                             ₹{plan.price.replace("₹", "")}
// //                                                         </td>
// //                                                     ))}
// //                                                 </tr>

// //                                                 {/* Features Rows */}
// //                                                 {subscriptionData.features.map((feature, index) => (
// //                                                     <tr key={feature} style={{
// //                                                         backgroundColor: index % 2 === 0 ? "#fff" : "#f9f9f9"
// //                                                     }}>
// //                                                         <td style={{
// //                                                             border: "1px solid #ccc",
// //                                                             padding: "10px",
// //                                                             fontSize: isMobile ? "13px" : "14px"
// //                                                         }}>
// //                                                             {feature}
// //                                                         </td>
// //                                                         {subscriptionData.plans.map(plan => (
// //                                                             <td key={`${plan.name}-${feature}`} style={{
// //                                                                 border: "1px solid #ccc",
// //                                                                 padding: "10px",
// //                                                                 textAlign: "center",
// //                                                                 fontSize: isMobile ? "13px" : "14px"
// //                                                             }}>
// //                                                                 {plan.features.includes(feature) ? (
// //                                                                     <span style={{
// //                                                                         color: "#4CAF50",
// //                                                                         fontWeight: "bold"
// //                                                                     }}>✔️</span>
// //                                                                 ) : (
// //                                                                     <span style={{
// //                                                                         color: "#f44336"
// //                                                                     }}>❌</span>
// //                                                                 )}
// //                                                             </td>
// //                                                         ))}
// //                                                     </tr>
// //                                                 ))}

// //                                                 {/* Description Row */}
// //                                                 <tr>
// //                                                     <td style={{
// //                                                         border: "1px solid #ccc",
// //                                                         padding: "10px",
// //                                                         fontWeight: "bold",
// //                                                         backgroundColor: "#f0f7ff"
// //                                                     }}>
// //                                                         Description
// //                                                     </td>
// //                                                     <td
// //                                                         colSpan={subscriptionData.plans.length}
// //                                                         style={{
// //                                                             border: "1px solid #ccc",
// //                                                             padding: "10px",
// //                                                             backgroundColor: "#f0f7ff",
// //                                                             fontStyle: "italic",
// //                                                             color: "#555"
// //                                                         }}
// //                                                     >
// //                                                         {subscriptionData.description}
// //                                                     </td>
// //                                                 </tr>

// //                                                 {/* Pay Now Row */}
// //                                                 <tr>
// //                                                     <td style={{
// //                                                         border: "1px solid #ccc",
// //                                                         padding: "10px",
// //                                                         fontWeight: "bold",
// //                                                         backgroundColor: "#f9f9f9"
// //                                                     }}>
// //                                                         Action
// //                                                     </td>
// //                                                     {subscriptionData.plans.map(plan => (
// //                                                         <td key={`action-${plan.name}`} style={{
// //                                                             border: "1px solid #ccc",
// //                                                             padding: "10px",
// //                                                             textAlign: "center",
// //                                                             backgroundColor: "#f9f9f9"
// //                                                         }}>
// //                                                             <button
// //                                                                 style={{
// //                                                                     padding: "8px 16px",
// //                                                                     backgroundColor: "#4CAF50",
// //                                                                     color: "white",
// //                                                                     border: "none",
// //                                                                     borderRadius: "4px",
// //                                                                     fontWeight: "bold",
// //                                                                     cursor: "pointer",
// //                                                                     fontSize: isMobile ? "13px" : "14px",
// //                                                                     minWidth: "100px"
// //                                                                 }}
// //                                                                 onClick={() => alert(`Selected ${plan.name} plan`)}
// //                                                             >
// //                                                                 Pay Now
// //                                                             </button>
// //                                                         </td>
// //                                                     ))}
// //                                                 </tr>
// //                                             </tbody>
// //                                         </table>
// //                                     </div>
// //                                 ) : (
// //                                     <div style={{
// //                                         textAlign: "center",
// //                                         padding: "40px",
// //                                         backgroundColor: "#f8f9fa",
// //                                         borderRadius: "8px",
// //                                         border: "2px dashed #ddd"
// //                                     }}>
// //                                         <div style={{ fontSize: "48px", marginBottom: "20px" }}>📋</div>
// //                                         {/* <h4 style={{ color: "#666", marginBottom: "10px" }}>
// //                                             No Plans to Display
// //                                         </h4> */}
// //                                         <p style={{ color: "#888" }}>
// //                                             Select service types above to view available subscription plans.
// //                                         </p>
// //                                     </div>
// //                                 )}
// //                             </div>


// //                         </div>
// //                     </div>
// //                     <div className="col-lg-3"></div>
// //                 </div>
// //             </div>
// //         </>
// //     );
// // }

// // export default SubscriptionPackages;


// import React, { useState } from "react";
// import { Link } from "react-router-dom";

// function SubscriptionPackages() {
//     const isMobile = window.innerWidth <= 768;
//     // Set DINE_IN as default selected
//     const [selectedServices, setSelectedServices] = useState({
//         DINE_IN: true,
//         TAKEAWAY: false,
//         DELIVERY: false,
//         TABLE_DINE_IN: false,
//         CATERINGS_SERVICES: false
//     });

//     // Service type configurations with individual pricing data
//     const serviceTypes = [
//         { 
//             id: "DINE_IN", 
//             label: "Dine-In",
//             plans: [
//                 { name: "BASIC", price: "₹2,000", days: "30", features: ["Home", "Company", "Menu", "Tables"] },
//                 { name: "STANDARD", price: "₹5,000", days: "90", features: ["Home", "Company", "Menu", "Tables", "Orders"] },
//                 { name: "PREMIUM", price: "₹10,000", days: "180", features: ["Home", "Company", "Menu", "Tables", "Orders", "Reports"] }
//             ],
//             features: ["Home", "Company", "Settings", "Menu", "Tables", "Orders", "Reports"],
//             description: "Subscription plans for dine-in restaurant services"
//         },
//         { 
//             id: "TAKEAWAY", 
//             label: "Takeaway",
//             plans: [
//                 { name: "BASIC", price: "₹1,500", days: "30", features: ["Home", "Company", "Menu"] },
//                 { name: "STANDARD", price: "₹4,000", days: "90", features: ["Home", "Company", "Menu", "Orders"] },
//                 { name: "PREMIUM", price: "₹8,000", days: "180", features: ["Home", "Company", "Menu", "Orders", "Reports"] }
//             ],
//             features: ["Home", "Company", "Settings", "Menu", "Orders", "Reports"],
//             description: "Subscription plans for takeaway services"
//         },
//         { 
//             id: "DELIVERY", 
//             label: "Delivery",
//             plans: [
//                 { name: "BASIC", price: "₹2,500", days: "30", features: ["Home", "Company", "Menu", "Delivery"] },
//                 { name: "STANDARD", price: "₹6,000", days: "90", features: ["Home", "Company", "Menu", "Delivery", "Orders"] },
//                 { name: "PREMIUM", price: "₹12,000", days: "180", features: ["Home", "Company", "Menu", "Delivery", "Orders", "Reports"] }
//             ],
//             features: ["Home", "Company", "Settings", "Menu", "Delivery", "Orders", "Reports"],
//             description: "Subscription plans for delivery services"
//         },
//         { 
//             id: "TABLE_DINE_IN", 
//             label: "Table Dine-In",
//             plans: [
//                 { name: "BASIC", price: "₹3,000", days: "30", features: ["Home", "Company", "Menu", "Tables"] },
//                 { name: "STANDARD", price: "₹7,000", days: "90", features: ["Home", "Company", "Menu", "Tables", "Orders"] },
//                 { name: "PREMIUM", price: "₹14,000", days: "180", features: ["Home", "Company", "Menu", "Tables", "Orders", "Reports"] }
//             ],
//             features: ["Home", "Company", "Settings", "Menu", "Tables", "Orders", "Reports"],
//             description: "Subscription plans for table booking and dine-in services"
//         },
//         { 
//             id: "CATERINGS_SERVICES", 
//             label: "Catering Services",
//             plans: [
//                 { name: "VISIBILITY_LEAD", price: "₹8,000", days: "30", features: ["Home", "Company", "Booking"] },
//                 { name: "BOOKINGS", price: "₹15,000", days: "90", features: ["Home", "Company", "Booking", "Orders"] },
//                 { name: "PREMIUM", price: "₹25,000", days: "180", features: ["Home", "Company", "Booking", "Orders", "Staff", "Reports"] }
//             ],
//             features: ["Home", "Company", "Settings", "Booking", "Orders", "Staff", "Reports", "Promotions"],
//             description: "Subscription plans for catering and event services"
//         }
//     ];

//     // Get selected services data
//     const getSelectedServicesData = () => {
//         const selected = serviceTypes.filter(service => selectedServices[service.id]);

//         if (selected.length === 0) {
//             return {
//                 title: "Please select service types to view plans.",
//                 description: "Select one or more service types to see subscription plans.",
//                 selectedServices: [],
//                 showCombinedTable: false
//             };
//         }

//         if (selected.length === 1) {
//             const service = selected[0];
//             return {
//                 title: `${service.label} Subscription Plans`,
//                 description: service.description,
//                 selectedServices: [service],
//                 showCombinedTable: false
//             };
//         }

//         // For multiple selections, show combined view
//         return {
//             title: "Combined Subscription Plans",
//             description: `Subscription plans for selected services: ${selected.map(s => s.label).join(", ")}`,
//             selectedServices: selected,
//             showCombinedTable: true
//         };
//     };

//     const handleServiceToggle = (serviceId) => {
//         setSelectedServices(prev => ({
//             ...prev,
//             [serviceId]: !prev[serviceId]
//         }));
//     };

//     const subscriptionData = getSelectedServicesData();

//     // Render individual service table
//     const renderServiceTable = (service) => (
//         <div key={service.id} style={{ marginBottom: "30px" }}>
//             <h3 style={{ 
//                 color: "#b15cd6", 
//                 marginBottom: "15px",
//                 fontSize: isMobile ? "18px" : "20px",
//                 paddingBottom: "10px",
//                 borderBottom: "2px solid #b15cd6"
//             }}>
//                 {service.label}
//             </h3>

//             <div style={{
//                 overflowX: "auto",
//                 borderRadius: "8px",
//                 border: "1px solid #ddd",
//                 marginBottom: "20px"
//             }}>
//                 <table style={{
//                     width: "100%",
//                     borderCollapse: "collapse",
//                     minWidth: isMobile ? "600px" : "auto"
//                 }}>
//                     <thead>
//                         <tr>
//                             <th style={{
//                                 border: "1px solid #ccc",
//                                 padding: "12px",
//                                 textAlign: "center",
//                                 fontWeight: "bold",
//                                 backgroundColor: "#b15cd6",
//                                 color: "white",
//                                 fontSize: isMobile ? "14px" : "16px"
//                             }}>
//                                 Feature
//                             </th>
//                             {service.plans.map((plan, index) => (
//                                 <th key={plan.name} style={{
//                                     border: "1px solid #ccc",
//                                     padding: "12px",
//                                     textAlign: "center",
//                                     fontWeight: "bold",
//                                     backgroundColor: "#b15cd6",
//                                     color: "white",
//                                     fontSize: isMobile ? "14px" : "16px"
//                                 }}>
//                                     <div style={{ fontSize: "16px", fontWeight: "bold" }}>
//                                         {plan.days} Days
//                                     </div>
//                                 </th>
//                             ))}
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {/* Price Row */}
//                         <tr>
//                             <td style={{
//                                 border: "1px solid #ccc",
//                                 padding: "10px",
//                                 fontWeight: "bold",
//                                 backgroundColor: "#f9f9f9"
//                             }}>
//                                 Price
//                             </td>
//                             {service.plans.map(plan => (
//                                 <td key={`price-${plan.name}`} style={{
//                                     border: "1px solid #ccc",
//                                     padding: "10px",
//                                     textAlign: "center",
//                                     fontWeight: "bold"
//                                 }}>
//                                     {plan.price}
//                                 </td>
//                             ))}
//                         </tr>

//                         {/* Features Rows */}
//                         {service.features.map((feature, index) => (
//                             <tr key={feature} style={{
//                                 backgroundColor: index % 2 === 0 ? "#fff" : "#f9f9f9"
//                             }}>
//                                 <td style={{
//                                     border: "1px solid #ccc",
//                                     padding: "10px",
//                                     fontSize: isMobile ? "13px" : "14px"
//                                 }}>
//                                     {feature}
//                                 </td>
//                                 {service.plans.map(plan => (
//                                     <td key={`${plan.name}-${feature}`} style={{
//                                         border: "1px solid #ccc",
//                                         padding: "10px",
//                                         textAlign: "center",
//                                         fontSize: isMobile ? "13px" : "14px"
//                                     }}>
//                                         {plan.features.includes(feature) ? (
//                                             <span style={{
//                                                 color: "#4CAF50",
//                                                 fontWeight: "bold"
//                                             }}>✔️</span>
//                                         ) : (
//                                             <span style={{
//                                                 color: "#f44336"
//                                             }}>❌</span>
//                                         )}
//                                     </td>
//                                 ))}
//                             </tr>
//                         ))}

//                         {/* Pay Now Row */}
//                         <tr>
//                             <td style={{
//                                 border: "1px solid #ccc",
//                                 padding: "10px",
//                                 fontWeight: "bold",
//                                 backgroundColor: "#f9f9f9"
//                             }}>
//                                 Action
//                             </td>
//                             {service.plans.map(plan => (
//                                 <td key={`action-${plan.name}`} style={{
//                                     border: "1px solid #ccc",
//                                     padding: "10px",
//                                     textAlign: "center",
//                                     backgroundColor: "#f9f9f9"
//                                 }}>
//                                     <button
//                                         style={{
//                                             padding: "8px 16px",
//                                             backgroundColor: "#4CAF50",
//                                             color: "white",
//                                             border: "none",
//                                             borderRadius: "4px",
//                                             fontWeight: "bold",
//                                             cursor: "pointer",
//                                             fontSize: isMobile ? "13px" : "14px",
//                                             minWidth: "100px"
//                                         }}
//                                         onClick={() => alert(`Selected ${plan.name} plan for ${service.label}`)}
//                                     >
//                                         Pay Now
//                                     </button>
//                                 </td>
//                             ))}
//                         </tr>
//                     </tbody>
//                 </table>
//             </div>
//         </div>
//     );

//     // Render combined table for multiple selections
//     const renderCombinedTable = () => {
//         // Get all unique features from all selected services
//         const allFeatures = Array.from(new Set(
//             subscriptionData.selectedServices.flatMap(service => service.features)
//         ));

//         // Get all plans (take the longest plans array from selected services)
//         const maxPlans = Math.max(...subscriptionData.selectedServices.map(s => s.plans.length));
//         const combinedPlans = Array.from({ length: maxPlans }, (_, i) => ({
//             name: `PLAN_${i + 1}`,
//             days: ["30", "90", "180"][i] || "30",
//             prices: subscriptionData.selectedServices.map(service => 
//                 service.plans[i]?.price || "N/A"
//             )
//         }));

//         return (
//             <div style={{
//                 overflowX: "auto",
//                 borderRadius: "8px",
//                 border: "1px solid #ddd",
//                 marginBottom: "20px"
//             }}>
//                 <table style={{
//                     width: "100%",
//                     borderCollapse: "collapse",
//                     minWidth: isMobile ? "800px" : "auto"
//                 }}>
//                     <thead>
//                         <tr>
//                             <th rowSpan="2" style={{
//                                 border: "1px solid #ccc",
//                                 padding: "12px",
//                                 textAlign: "center",
//                                 fontWeight: "bold",
//                                 backgroundColor: "#b15cd6",
//                                 color: "white",
//                                 fontSize: isMobile ? "14px" : "16px"
//                             }}>
//                                 Feature
//                             </th>
//                             {subscriptionData.selectedServices.map((service, idx) => (
//                                 <th key={service.id} colSpan={combinedPlans.length} style={{
//                                     border: "1px solid #ccc",
//                                     padding: "12px",
//                                     textAlign: "center",
//                                     fontWeight: "bold",
//                                     backgroundColor: "#b15cd6",
//                                     color: "white",
//                                     fontSize: isMobile ? "14px" : "16px"
//                                 }}>
//                                     {service.label}
//                                 </th>
//                             ))}
//                         </tr>
//                         <tr>
//                             {subscriptionData.selectedServices.flatMap(service => 
//                                 combinedPlans.map((plan, idx) => (
//                                     <th key={`${service.id}-${plan.name}`} style={{
//                                         border: "1px solid #ccc",
//                                         padding: "10px",
//                                         textAlign: "center",
//                                         fontWeight: "bold",
//                                         backgroundColor: "#a04bc0",
//                                         color: "white",
//                                         fontSize: isMobile ? "13px" : "14px"
//                                     }}>
//                                         {plan.days} Days
//                                     </th>
//                                 ))
//                             )}
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {/* Price Row */}
//                         <tr>
//                             <td style={{
//                                 border: "1px solid #ccc",
//                                 padding: "10px",
//                                 fontWeight: "bold",
//                                 backgroundColor: "#f9f9f9"
//                             }}>
//                                 Price
//                             </td>
//                             {subscriptionData.selectedServices.flatMap(service => 
//                                 combinedPlans.map((plan, idx) => (
//                                     <td key={`price-${service.id}-${idx}`} style={{
//                                         border: "1px solid #ccc",
//                                         padding: "10px",
//                                         textAlign: "center",
//                                         fontWeight: "bold"
//                                     }}>
//                                         {service.plans[idx]?.price || "N/A"}
//                                     </td>
//                                 ))
//                             )}
//                         </tr>

//                         {/* Features Rows */}
//                         {allFeatures.map((feature, index) => (
//                             <tr key={feature} style={{
//                                 backgroundColor: index % 2 === 0 ? "#fff" : "#f9f9f9"
//                             }}>
//                                 <td style={{
//                                     border: "1px solid #ccc",
//                                     padding: "10px",
//                                     fontSize: isMobile ? "13px" : "14px"
//                                 }}>
//                                     {feature}
//                                 </td>
//                                 {subscriptionData.selectedServices.flatMap(service => 
//                                     combinedPlans.map((plan, idx) => (
//                                         <td key={`${service.id}-${feature}-${idx}`} style={{
//                                             border: "1px solid #ccc",
//                                             padding: "10px",
//                                             textAlign: "center",
//                                             fontSize: isMobile ? "13px" : "14px"
//                                         }}>
//                                             {service.features.includes(feature) && service.plans[idx]?.features.includes(feature) ? (
//                                                 <span style={{
//                                                     color: "#4CAF50",
//                                                     fontWeight: "bold"
//                                                 }}>✔️</span>
//                                             ) : (
//                                                 <span style={{
//                                                     color: "#f44336"
//                                                 }}>❌</span>
//                                             )}
//                                         </td>
//                                     ))
//                                 )}
//                             </tr>
//                         ))}
//                     </tbody>
//                 </table>
//             </div>
//         );
//     };

//     return (
//         <>
//             <div className="container-fluid company-mobile-data">
//                 <div className="row">
//                     <div className="col-lg-2"></div>
//                     <div className="col-lg-7">
//                         <p
//                             className="breadcrumb maamaas-home-bredcum"
//                             style={{
//                                 position: "fixed",
//                                 top: window.innerWidth <= 425 ? "50px" : window.innerWidth > 425 && window.innerWidth <= 768 ? "55px" : "64px",
//                                 left: "2vw",
//                                 width: "100%",
//                                 backgroundColor: "#fff",
//                                 zIndex: 1000,
//                                 padding: "10px 0",
//                                 fontSize: isMobile ? "16px" : "18px",
//                                 fontWeight: isMobile ? "normal" : "bold",
//                                 textAlign: "center",
//                                 margin: 0,
//                             }}
//                         >
//                             <Link
//                                 to="/foodladingpage"
//                                 style={{
//                                     color: "purple",
//                                     fontWeight: "bold",
//                                     textDecoration: "none",
//                                 }}
//                             >
//                                 Food & Beverages
//                             </Link>
//                             <span className="separator"> &gt; </span>
//                             <Link
//                                 style={{
//                                     color: "purple",
//                                     fontWeight: "bold",
//                                     textDecoration: "none",
//                                 }}
//                             >
//                                 Subscriptions
//                             </Link>
//                         </p>

//                         {/* Main Content Container */}
//                         <div style={{
//                             marginTop: "100px",
//                             padding: isMobile ? "15px" : "20px",
//                             backgroundColor: "#fff",
//                             borderRadius: "10px",
//                         }}>
//                             {/* Service Selection Section - Simple Checkboxes */}
//                             <div style={{ marginBottom: "30px" }}>
//                                 <h3 style={{
//                                     marginBottom: "15px",
//                                     color: "#333",
//                                     fontSize: isMobile ? "18px" : "20px"
//                                 }}>
//                                     Select Service Types
//                                 </h3>

//                                 <div style={{
//                                     display: "flex",
//                                     flexWrap: "wrap",
//                                     gap: "20px",
//                                     alignItems: "center",
//                                     padding: "15px",
//                                     backgroundColor: "#f8f9fa",
//                                     borderRadius: "8px",
//                                     border: "1px solid #e0e0e0"
//                                 }}>
//                                     {serviceTypes.map(service => (
//                                         <label
//                                             key={service.id}
//                                             style={{
//                                                 display: "flex",
//                                                 alignItems: "center",
//                                                 gap: "8px",
//                                                 cursor: "pointer",
//                                                 fontSize: isMobile ? "14px" : "16px",
//                                                 color: selectedServices[service.id] ? "#b15cd6" : "#333",
//                                                 fontWeight: selectedServices[service.id] ? "bold" : "normal"
//                                             }}
//                                         >
//                                             <input
//                                                 type="checkbox"
//                                                 checked={selectedServices[service.id]}
//                                                 onChange={() => handleServiceToggle(service.id)}
//                                                 style={{
//                                                     width: "18px",
//                                                     height: "18px",
//                                                     cursor: "pointer",
//                                                     accentColor: "#b15cd6"
//                                                 }}
//                                             />
//                                             {service.label}
//                                         </label>
//                                     ))}
//                                 </div>
//                             </div>

//                             {/* Subscription Plans Section */}
//                             <div>
//                                 <h2 style={{
//                                     textAlign: "center",
//                                     color: "#b15cd6",
//                                     marginBottom: "10px",
//                                     fontSize: isMobile ? "20px" : "24px"
//                                 }}>
//                                     {subscriptionData.title}
//                                 </h2>

//                                 <p style={{
//                                     textAlign: "center",
//                                     color: "#666",
//                                     marginBottom: "30px",
//                                     fontSize: isMobile ? "14px" : "16px",
//                                     lineHeight: "1.5"
//                                 }}>
//                                     {subscriptionData.description}
//                                 </p>

//                                 {/* Render tables based on selection */}
//                                 {subscriptionData.selectedServices.length === 0 ? (
//                                     <div style={{
//                                         textAlign: "center",
//                                         padding: "40px",
//                                         backgroundColor: "#f8f9fa",
//                                         borderRadius: "8px",
//                                         border: "2px dashed #ddd"
//                                     }}>
//                                         <div style={{ fontSize: "48px", marginBottom: "20px" }}>📋</div>
//                                         <p style={{ color: "#888" }}>
//                                             Select service types above to view available subscription plans.
//                                         </p>
//                                     </div>
//                                 ) : subscriptionData.showCombinedTable ? (
//                                     renderCombinedTable()
//                                 ) : (
//                                     subscriptionData.selectedServices.map(renderServiceTable)
//                                 )}
//                             </div>
//                         </div>
//                     </div>
//                     <div className="col-lg-3"></div>
//                 </div>
//             </div>
//         </>
//     );
// }

// export default SubscriptionPackages;


import React, { useState } from "react";
import { Link } from "react-router-dom";

function SubscriptionPackages() {
    const isMobile = window.innerWidth <= 768;
    // Set DINE_IN as default selected
    const [selectedServices, setSelectedServices] = useState({
        DINE_IN: true,
        TAKEAWAY: false,
        DELIVERY: false,
        TABLE_DINE_IN: false,
        CATERINGS_SERVICES: false
    });

    // Service type configurations with individual pricing data
    const serviceTypes = [
        {
            id: "DINE_IN",
            label: "Dine-In",
            plans: [
                {
                    name: "BASIC",
                    price: "₹2,000",
                    days: "30",
                    features: ["Home", "Company", "Settings", "Menu", "Tables", "Order"]
                },
                {
                    name: "STANDARD",
                    price: "₹5,000",
                    days: "90",
                    features: ["Home", "Company", "Settings", "Menu", "Tables", "Order", "Chef", "Report"]
                },
                {
                    name: "PREMIUM",
                    price: "₹10,000",
                    days: "180",
                    features: ["Home", "Company", "Settings", "Menu", "Tables", "Order", "Chef", "Delivery", "Team", "Account", "Promotions", "Report", "Inventory"]
                }
            ],
            features: ["Price", "Home", "Company", "Settings", "Menu", "Tables", "Order", "Chef", "Delivery", "Team", "Account", "Promotions", "Report", "Inventory", "Support", "Legal", "Notification"]
        },
        {
            id: "TAKEAWAY",
            label: "Takeaway",
            plans: [
                {
                    name: "BASIC",
                    price: "₹1,500",
                    days: "30",
                    features: ["Home", "Company", "Settings", "Menu", "Order"]
                },
                {
                    name: "STANDARD",
                    price: "₹4,000",
                    days: "90",
                    features: ["Home", "Company", "Settings", "Menu", "Order", "Report"]
                },
                {
                    name: "PREMIUM",
                    price: "₹8,000",
                    days: "180",
                    features: ["Home", "Company", "Settings", "Menu", "Order", "Delivery", "Account", "Promotions", "Report", "Inventory"]
                }
            ],
            features: ["Price", "Home", "Company", "Settings", "Menu", "Order", "Delivery", "Account", "Promotions", "Report", "Inventory", "Support", "Legal", "Notification"]
        },
        {
            id: "DELIVERY",
            label: "Delivery",
            plans: [
                {
                    name: "BASIC",
                    price: "₹2,500",
                    days: "30",
                    features: ["Home", "Company", "Settings", "Menu", "Order", "Delivery"]
                },
                {
                    name: "STANDARD",
                    price: "₹6,000",
                    days: "90",
                    features: ["Home", "Company", "Settings", "Menu", "Order", "Delivery", "Report"]
                },
                {
                    name: "PREMIUM",
                    price: "₹12,000",
                    days: "180",
                    features: ["Home", "Company", "Settings", "Menu", "Order", "Delivery", "Team", "Account", "Promotions", "Report", "Inventory"]
                }
            ],
            features: ["Price", "Home", "Company", "Settings", "Menu", "Order", "Delivery", "Team", "Account", "Promotions", "Report", "Inventory", "Support", "Legal", "Notification"]
        },
        {
            id: "TABLE_DINE_IN",
            label: "Table Dine-In",
            plans: [
                {
                    name: "BASIC",
                    price: "₹3,000",
                    days: "30",
                    features: ["Home", "Company", "Settings", "Menu", "Tables", "Order"]
                },
                {
                    name: "STANDARD",
                    price: "₹7,000",
                    days: "90",
                    features: ["Home", "Company", "Settings", "Menu", "Tables", "Order", "Chef", "Report"]
                },
                {
                    name: "PREMIUM",
                    price: "₹14,000",
                    days: "180",
                    features: ["Home", "Company", "Settings", "Menu", "Tables", "Order", "Chef", "Team", "Account", "Promotions", "Report", "Inventory"]
                }
            ],
            features: ["Price", "Home", "Company", "Settings", "Menu", "Tables", "Order", "Chef", "Team", "Account", "Promotions", "Report", "Inventory", "Support", "Legal", "Notification"]
        },
        {
            id: "CATERINGS_SERVICES",
            label: "Catering Services",
            plans: [
                {
                    name: "VISIBILITY_LEAD",
                    price: "₹8,000",
                    days: "30",
                    features: ["Home", "Company", "Settings", "Menu", "Booking"]
                },
                {
                    name: "BOOKINGS",
                    price: "₹15,000",
                    days: "90",
                    features: ["Home", "Company", "Settings", "Menu", "Booking", "Order"]
                },
                {
                    name: "PREMIUM",
                    price: "₹25,000",
                    days: "180",
                    features: ["Home", "Company", "Settings", "Menu", "Booking", "Order", "Account", "Promotions", "Report"]
                }
            ],
            features: ["Price", "Home", "Company", "Settings", "Menu", "Booking", "Order", "Account", "Promotions", "Report"]
        }
    ];

    // Get selected services
    const selectedServicesList = serviceTypes.filter(service => selectedServices[service.id]);

    // Get all unique features from selected services
    const getAllFeatures = () => {
        const allFeatures = new Set(["Price"]); // Always include Price
        selectedServicesList.forEach(service => {
            service.features.forEach(feature => {
                if (feature !== "Price") allFeatures.add(feature);
            });
        });
        return Array.from(allFeatures);
    };

    // Calculate combined prices for multiple services
    const getCombinedPlans = () => {
        // For single service, use its plans
        if (selectedServicesList.length === 1) {
            return selectedServicesList[0].plans;
        }

        // For multiple services, calculate combined prices and combine features
        return [
            {
                name: "COMBINED_BASIC",
                price: `₹${selectedServicesList.reduce((sum, service) => {
                    const price = parseInt(service.plans[0].price.replace(/[₹,]/g, ''));
                    return sum + price;
                }, 0).toLocaleString('en-IN')}`,
                days: "30",
                // Combine features from ALL services for this plan
                features: Array.from(new Set(
                    selectedServicesList.flatMap(service => service.plans[0].features)
                ))
            },
            {
                name: "COMBINED_STANDARD",
                price: `₹${selectedServicesList.reduce((sum, service) => {
                    const price = parseInt(service.plans[1].price.replace(/[₹,]/g, ''));
                    return sum + price;
                }, 0).toLocaleString('en-IN')}`,
                days: "90",
                features: Array.from(new Set(
                    selectedServicesList.flatMap(service => service.plans[1].features)
                ))
            },
            {
                name: "COMBINED_PREMIUM",
                price: `₹${selectedServicesList.reduce((sum, service) => {
                    const price = parseInt(service.plans[2].price.replace(/[₹,]/g, ''));
                    return sum + price;
                }, 0).toLocaleString('en-IN')}`,
                days: "180",
                features: Array.from(new Set(
                    selectedServicesList.flatMap(service => service.plans[2].features)
                ))
            }
        ];
    };

    const handleServiceToggle = (serviceId) => {
        setSelectedServices(prev => ({
            ...prev,
            [serviceId]: !prev[serviceId]
        }));
    };

    const combinedPlans = getCombinedPlans();
    const allFeatures = getAllFeatures();

    // Check if a feature is available in a plan for selected services
    const isFeatureAvailable = (feature, planIndex) => {
        if (feature === "Price") return true; // Price is always available

        // For single service
        if (selectedServicesList.length === 1) {
            const service = selectedServicesList[0];
            return service.plans[planIndex].features.includes(feature);
        }

        // FIX: For multiple services, check if ANY selected service has this feature in this plan
        // This is correct because when you subscribe to multiple services, you get access to ALL their features
        return selectedServicesList.some(service =>
            service.features.includes(feature) &&
            service.plans[planIndex]?.features.includes(feature)
        );
    };

    return (
        <>
            <div className="container-fluid company-mobile-data">
                <div className="row">
                    <div className="col-lg-2"></div>
                    <div className="col-lg-8">
                        <p
                            className="breadcrumb maamaas-home-bredcum"
                            style={{
                                position: "fixed",
                                top: window.innerWidth <= 425 ? "50px" : window.innerWidth > 425 && window.innerWidth <= 768 ? "55px" : "64px",
                                left: "2vw",
                                width: "100%",
                                backgroundColor: "#fff",
                                zIndex: 1000,
                                padding: "10px 0",
                                fontSize: isMobile ? "16px" : "18px",
                                fontWeight: isMobile ? "normal" : "bold",
                                textAlign: "center",
                                margin: 0,
                            }}
                        >
                            <Link
                                to="/foodladingpage"
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Food & Beverages
                            </Link>
                            <span className="separator"> &gt; </span>
                            <Link
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Subscriptions
                            </Link>
                        </p>

                        {/* Main Content Container */}
                        <div style={{
                            marginTop:window.innerWidth<768 ? " 40px": "100px",
                            padding: isMobile ? "15px" : "20px",
                            backgroundColor: "#fff",
                            borderRadius: "10px",
                            width:window.innerWidth< 700 ? "94vw": " ",
                        }}>
                            {/* Service Selection Section */}
                            <div style={{ marginBottom: "30px" }}>
                                <h3 style={{
                                    marginBottom: "15px",
                                    color: "#333",
                                    fontSize: isMobile ? "18px" : "20px"
                                }}>
                                    Select Service Types
                                </h3>

                                <div style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "20px",
                                    alignItems: "center",
                                    padding: "15px",
                                    backgroundColor: "#f8f9fa",
                                    borderRadius: "8px",
                                    border: "1px solid #e0e0e0"
                                }}>
                                    {serviceTypes.map(service => (
                                        <label
                                            key={service.id}
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                                cursor: "pointer",
                                                fontSize: isMobile ? "14px" : "16px",
                                                color: selectedServices[service.id] ? "#b15cd6" : "#333",
                                                fontWeight: selectedServices[service.id] ? "normal" : "normal"
                                            }}
                                        >
                                            <input
                                                type="checkbox"
                                                checked={selectedServices[service.id]}
                                                onChange={() => handleServiceToggle(service.id)}
                                                style={{
                                                    width: "18px",
                                                    height: "18px",
                                                    cursor: "pointer",
                                                    accentColor: "#b15cd6"
                                                }}
                                            />
                                            {service.label}
                                        </label>
                                    ))}
                                </div>
                            </div>

                            {/* Single Table for All Selected Services */}
                            {selectedServicesList.length > 0 ? (
                                <div>
                                    <h2 style={{
                                        textAlign: "center",
                                        color: "#b15cd6",
                                        marginBottom: "20px",
                                        fontSize: isMobile ? "20px" : "24px"
                                    }}>
                                        {selectedServicesList.length === 1
                                            ? `${selectedServicesList[0].label} Subscription Plans`
                                            : "Combined Subscription Plans"
                                        }
                                    </h2>

                                    

                                    <div style={{
                                        overflowX: "auto",
                                        borderRadius: "8px",
                                        border: "1px solid #ddd",
                                        height:"50vh",
                                        scrollbarWidth:"none",
                                    }}>
                                        <table style={{
                                            width: "100%",
                                            borderCollapse: "collapse",
                                            minWidth: isMobile ? "600px" : "auto"
                                        }}>
                                            <thead>
                                                <tr>
                                                    <th style={{
                                                        border: "1px solid #ccc",
                                                        padding: "12px",
                                                        textAlign: "center",
                                                        fontWeight: "bold",
                                                        backgroundColor: "#b15cd6",
                                                        color: "white",
                                                        fontSize: isMobile ? "14px" : "16px"
                                                    }}>
                                                        Feature
                                                    </th>
                                                    {combinedPlans.map((plan, index) => (
                                                        <th key={plan.name} style={{
                                                            border: "1px solid #ccc",
                                                            padding: "12px",
                                                            textAlign: "center",
                                                            fontWeight: "bold",
                                                            backgroundColor: "#b15cd6",
                                                            color: "white",
                                                            fontSize: isMobile ? "14px" : "16px"
                                                        }}>
                                                            {plan.days} Days
                                                        </th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {allFeatures.map((feature, featureIndex) => (
                                                    <tr key={feature} style={{
                                                        backgroundColor: featureIndex % 2 === 0 ? "#fff" : "#f9f9f9"
                                                    }}>
                                                        <td style={{
                                                            border: "1px solid #ccc",
                                                            padding: "10px",
                                                            fontWeight: feature === "Price" ? "bold" : "normal",
                                                            fontSize: isMobile ? "13px" : "14px"
                                                        }}>
                                                            {feature === "Price" ? "Price" : feature}
                                                        </td>
                                                        {combinedPlans.map((plan, planIndex) => (
                                                            <td key={`${feature}-${planIndex}`} style={{
                                                                border: "1px solid #ccc",
                                                                padding: "10px",
                                                                textAlign: "center",
                                                                fontSize: isMobile ? "13px" : "14px",
                                                                fontWeight: feature === "Price" ? "bold" : "normal"
                                                            }}>
                                                                {feature === "Price" ? (
                                                                    <strong>{plan.price}</strong>
                                                                ) : isFeatureAvailable(feature, planIndex) ? (
                                                                    <span style={{
                                                                        color: "#4CAF50",
                                                                        fontWeight: "bold",
                                                                        fontSize: "18px"
                                                                    }}>✔️</span>
                                                                ) : (
                                                                    <span style={{
                                                                        color: "#f44336",
                                                                        fontSize: "18px"
                                                                    }}>❌</span>
                                                                )}
                                                            </td>
                                                        ))}
                                                    </tr>
                                                ))}

                                                {/* Pay Now Row */}
                                                <tr>
                                                    <td style={{
                                                        border: "1px solid #ccc",
                                                        padding: "10px",
                                                        fontWeight: "bold",
                                                        backgroundColor: "#f9f9f9"
                                                    }}>
                                                        Action
                                                    </td>
                                                    {combinedPlans.map((plan, index) => (
                                                        <td key={`action-${index}`} style={{
                                                            border: "1px solid #ccc",
                                                            padding: "10px",
                                                            textAlign: "center",
                                                            backgroundColor: "#f9f9f9"
                                                        }}>
                                                            <button
                                                                style={{
                                                                    padding: "8px 16px",
                                                                    backgroundColor: "#4CAF50",
                                                                    color: "white",
                                                                    border: "none",
                                                                    borderRadius: "4px",
                                                                    fontWeight: "bold",
                                                                    cursor: "pointer",
                                                                    fontSize: isMobile ? "13px" : "14px",
                                                                    minWidth: "100px"
                                                                }}
                                                                onClick={() => {
                                                                    const services = selectedServicesList.map(s => s.label).join(", ");
                                                                    alert(`Selected ${plan.days} Days plan for: ${services}\nPrice: ${plan.price}`);
                                                                }}
                                                            >
                                                                Pay Now
                                                            </button>
                                                        </td>
                                                    ))}
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            ) : (
                                <div style={{
                                    textAlign: "center",
                                    padding: "40px",
                                    backgroundColor: "#f8f9fa",
                                    borderRadius: "8px",
                                    border: "2px dashed #ddd"
                                }}>
                                    <div style={{ fontSize: "48px", marginBottom: "20px" }}>📋</div>
                                    <p style={{ color: "#888" }}>
                                        Select service types above to view available subscription plans.
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="col-lg-2"></div>
                </div>
            </div>
        </>
    );
}

export default SubscriptionPackages;